import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import Pagination from '@/components/pagination-new/Pagination';
import useScrollToTop from '@/hooks/useScrollToTop';

import useQuery from './useQuery';
// import DistanceFilter from './DistanceFilter';

import PaginationInformation from '@/components/pagination-new/PaginationInformation';
// import TypeFilter from './TypeFilter';







Projects.propTypes = {
  children: PropTypes.func.isRequired,
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string
    })
  })
};

export default function Projects(props) {
  const { router, children } = props;
  const { location } = router;

  const search = queryString.parse(location.search);





  const node = useRef();
  const scrollToTop = useScrollToTop();

  const pageSize = 4;

  const result = useQuery({
    search,
    pageSize
  });








  return (
    <>
      {/*<div ref={node} className="flex items-center justify-between">*/}
      {/*  <PaginationInformation*/}
      {/*    pageSize={pageSize}*/}
      {/*    totalCount={result.meta?.totalCount}*/}
      {/*  />*/}
      {/*</div>*/}
      <div ref={node} className="flex flex-wrap gap-4 justify-between items-end">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount} />
        
        {/*<div className="flex space-x-4">*/}
        {/*  <NetworkFilter />*/}
        {/*  /!*<TypeFilter />*!/*/}
        {/*  /!*<DistanceFilter />*!/*/}
        {/*</div>*/}
        <div className="flex flex-wrap gap-4">
          {/*<SortBy/>*/}
          {/*<FilterButton*/}
          {/*  count={filterCount}*/}
          {/*  onClick={showFilters}*/}
          {/*/>*/}
        </div>
      </div>
      {children(result)}
      <div className="flex flex-wrap gap-4 items-center justify-between">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount} />
        
        <Pagination
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
          onNavigate={() => scrollToTop(node)} />
        
      </div>
    </>);

}